import { useTranslation } from 'react-i18next';
import { StatCard } from '@/shared/ui';
import type { StatsData } from '../../model/types';

interface MovementsStatsProps {
  stats: StatsData | null;
  isLoading: boolean;
}

export function MovementsStats({ stats, isLoading }: MovementsStatsProps) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
      <StatCard
        label={t('welcome.chart.totvol.rec.label', 'Total Volume Received')}
        value={stats?.totalVolume || ''}
        isLoading={isLoading}
      />
      <StatCard
        label={t('welcome.chart.lost.label', 'Lost')}
        value={stats?.lossTotal || ''}
        variant="destructive"
        isLoading={isLoading}
      />
      <StatCard
        label={t('welcome.chart.damaged.label', 'Damaged')}
        value={stats?.damageTotal || ''}
        variant="warning"
        isLoading={isLoading}
      />
      <StatCard
        label={t('report_storageOverview_movements_longStandingStockLabel', 'Long Standing Stock')}
        value={stats?.longStandingPerc || ''}
        isLoading={isLoading}
      />
    </div>
  );
}
